import _objectSpread from "@babel/runtime/helpers/objectSpread2";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["position", "isVisible"];
import { forwardRef } from 'react';
import ReactDOM from 'react-dom';
import TooltipContent from "./TooltipContent";
import { jsx as _jsx } from "react/jsx-runtime";
var TooltipPopup = function TooltipPopup(_ref, forwardedRef) {
  var position = _ref.position,
    isVisible = _ref.isVisible,
    rest = _objectWithoutProperties(_ref, _excluded);
  return isVisible ? /*#__PURE__*/ReactDOM.createPortal(/*#__PURE__*/_jsx(TooltipContent, _objectSpread({
    position: position,
    isVisible: isVisible,
    ref: forwardedRef
  }, rest)), document.body) : null;
};
export default /*#__PURE__*/forwardRef(TooltipPopup);